import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import '@fontsource/fraunces/600.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import App from './App.jsx';
import './styles.css';
import './modern.css';
import './side-pages.css';
import './redesign.css';
import './round2.css';

const rootElement = document.getElementById('root');
const tree = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (!rootElement) {
  console.error('Root element not found');
} else if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, tree);
} else {
  createRoot(rootElement).render(tree);
}
